import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .hidden {
    display: none;
  }

  .inherit {
    display: inherit;
  }

  h3 {
    font-size: 20px;
    font-weight: 600;
  }

  .price-history-container {
    width: 100%;
  }

  .price-history-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: left;
    width: 100%;
  }

  .price-item {
    border-bottom: 1px solid #ebebeb;
    padding: 20px 0px;
    font-size: 16px;
  }

  .price-history-price {
    text-align: right;
    font-size: 16px;
    font-weight: 600;
  }

  @media (min-width: ${screen.smMin}) {
    .price-history-price {
      font-size: 18px;
    }
  }

  .price-history-date {
    font-size: 14px;
    position: relative;
  }

  @media (min-width: ${screen.smMin}) {
    .price-history-date {
      font-size: 16px;
    }
  }

  .dot {
    position: absolute;
    top: 24px;
    left: -24px;
    width: 14px;
    height: 14px;
  }

  @media (min-width: ${screen.smMin}) {
    .dot {
      left: -32px;
      top: 25px;
    }
  }

  .gray-dot {
    position: absolute;
    top: 25px;
    left: -22px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${colors.G2};
  }

  @media (min-width: ${screen.smMin}) {
    .gray-dot {
      top: 27px;
      left: -30px;
    }
  }

  .price-history-delta {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: ${screen.smMin}) {
    .price-history-delta {
      font-size: 16px;
    }
  }

  .green {
    color: ${colors.ALG2};
  }

  .red {
    color: ${colors.ALR1};
  }

  .black {
    color: ${colors.BLACK};
  }

  .strike-through {
    text-decoration: line-through;
    color: ${colors.G3};
  }

  .empty-copy {
    color: ${colors.G3};
    font-size: 16px;
    font-weight: 400;
    display: flex;
    margin-top: 10px;
    justify-content: center;
  }

  .empty-state {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 40px;
    padding-right: 7px;
    padding-bottom: 40px;
  }

  @media (min-width: ${screen.smMin}) {
    .empty-state {
      padding-top: 35px;
      padding-bottom: 6px;
    }
  }

  .graph-icon {
    width: 40px;
    height: 31.45px;
  }
`;
